import {firebaseClient} from '@/api/axios';
import {ATLAS_DB} from '@/config/firebase';
import {setDataStatus} from '@/redux/slice/appSlice';
import store from '@/redux/store';
import {generateDataStatus} from '@/services/data-status';

export const getAllDataStatus = async () => {
  const data = await firebaseClient.get(`${ATLAS_DB}/cron_timestamps.json`);
  const finalData = generateDataStatus(data.data);
  store.dispatch(setDataStatus(finalData));
};
